import { injectBrandFonts, type BrandFontFace } from '../../shared/font-injector';

const FONT_BASE_URL = `${process.env.REACT_APP_MEDIA_DOMAIN}/brands/assets/HIPOTECARIO/fonts`;

const FONTS: BrandFontFace[] = [
  // VAG Rounded
  { family: 'VAG Rounded', weight: 100, style: 'normal', file: 'VAGRounded-Thin.ttf', format: 'truetype' },
  { family: 'VAG Rounded', weight: 300, style: 'normal', file: 'VAGRounded-Light-3.ttf', format: 'truetype' },
  { family: 'VAG Rounded', weight: 700, style: 'normal', file: 'VAGRounded-Bold.ttf', format: 'truetype' },
  { family: 'VAG Rounded', weight: 900, style: 'normal', file: 'VAGRounded-Black.ttf', format: 'truetype' },
  {
    family: 'Avenir Next Rounded Pro',
    weight: 500,
    style: 'normal',
    file: 'avenir-next-rounded-pro-medium.otf',
    format: 'opentype'
  }
];

export function injectHipotecarioFonts() {
  injectBrandFonts({ styleId: 'hipotecario-fonts', baseUrl: FONT_BASE_URL, fonts: FONTS });
}
